import { Button } from "@mantine/core";
import { IIssueApi } from "@schemas/issueSchema";
import { IconLock } from "@tabler/icons-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "moment/dist/locale/nb";
import React from "react";
import { TaskCompletedCount } from "../../../components";
import { ActionIcon, IssueIcon } from "../../../components/CustomIcons/CustomIcons";
import { getTaskCompleteCount } from "./issueUtils";

export const IssueIdWithAksjonCompletedCount: React.FC<{
  issue: IIssueApi;
  setSelectedIssue: (issue: IIssueApi) => void;
  id: string;
  showClientLock?: boolean;
}> = ({ issue, setSelectedIssue, id, showClientLock = false }) => {
  return (
    <div className="d-flex align-items-center">
      {issue._id != null && <IssueIdButton issue={issue} setSelectedIssue={setSelectedIssue} id={id} />}
      {showClientLock === true && (
        <IconLock color="var(--mantine-color-red-6)" size={16} style={{ flexShrink: 0, marginLeft: 4 }} />
      )}
      <div className="flex-fill" />
      <TaskCompletedCount taskCompleteCount={getTaskCompleteCount(issue, true)} />
    </div>
  );
};

export const IssueIdButton: React.FC<{ issue: IIssueApi; setSelectedIssue: (issue: IIssueApi) => void; id: any }> = ({
  issue,
  setSelectedIssue,
  id,
}) => {
  return (
    <Button color="mc-primary" variant="subtle" px={"xs"} size="sm" onClick={() => setSelectedIssue(issue)}>
      {issue.taskOrIssue === "ISSUE" && (
        <span>
          <b>
            <u>
              <IssueIcon style={{ marginRight: "4px", fontSize: ".9em", marginBottom: "3px" }} />
              {id}
            </u>
          </b>
        </span>
      )}
      {issue.taskOrIssue === "TASK" && (
        <span>
          <ActionIcon className="mr-1 text-secondary" style={{ marginBottom: "3px", fontSize: "1.1em" }} />
          {id}
        </span>
      )}
    </Button>
  );
};
